import 'scss/services/customer-case.scss'
import 'babel-polyfill'
import { getCustomerCases } from 'js/api/customer-case'
import {
  serviceTopbar
} from 'js/libs/utils-services'

// 获取左侧导航栏列表
function getNavList (list) {
  var str = `<li class="active sidebar-main-item" data-index="0"><i class="icons icons-sidebar icons-sidebar-${list[0].typeIcon}"></i>${list[0].name}</li>`
  for (var i = 1; i < list.length; i++) {
    str += `<li class="sidebar-main-item" data-index=${i}><i class="icons icons-sidebar icons-sidebar-${list[i].typeIcon}"></i>${list[i].name}</li>`
  }
  $('.sidebar-content').append(str)
  iconHoverin($('.sidebar-content .active'))
}

// 获取合作案例列表
function getCustomerCase (list) {
  var str = ''
  for (var i = 0; i < list.length; i++) {
    var caseLi = ''
    for (var k = 0; k < list[i].product.length; k++) {
      caseLi += `<li><a href="${list[i].product[k].productUrl}" target="_blank">${list[i].product[k].productName}</a></li>`
      if (k < list[i].product.length - 1) {
        caseLi += `<span>/</span>`
      }
    }
    var caseName = ''
    if (list[i].productName && list[i].companyName) {
      caseName += `<span class="customer-name">${list[i].productName}</span>
      <span class="vline"></span>
      <span class="customer-company">${list[i].companyName}</span>`
    } else if (list[i].productName) {
      caseName += `<span class="customer-name">${list[i].productName}</span>`
    } else if (list[i].companyName) {
      caseName += `<span class="customer-name">${list[i].companyName}</span>`
    }
    str += `<li class="customer-case">
      <div class="customer-icon"><img src="${list[i].logo}" alt="" style="max-height: 140px; max-width: 180px"></div>
      <div class="customer-info">
        ${caseName}
        <p class="customer-case-intro">${list[i].detail}</p>
        <div class="customer-case-abilities">
          <span class="abilities-list">使用产品: </span>
          <ul>${caseLi}</ul>
        </div>
      </div>
    </li>`
  }
  $('.typical-customer-cases').append(str)
}

function getCaseStr (index, caseList, caseStr) {
  var listlen = 0
  if (caseList[index].list.length <= 10) {
    listlen = caseList[index].list.length
  } else {
    listlen = 10
  }
  for (var i = 0; i < listlen; i++) {
    caseStr.push(caseList[index].list[i])
  }
}

function iconHoverin ($this) {
  var iconClass = $this.find('i').attr('class').split(' ')[2]
  if (!(iconClass.indexOf('_b') > -1)) {
    var hoverClass = iconClass + '_b'
    $this.find('i').removeClass(iconClass).addClass(hoverClass)
  }
}
function iconHoverout ($this) {
  var hoverClass = $this.find('i').attr('class').split(' ')[2]
  var iconClass = hoverClass.replace('_b', '')
  if (!(iconClass.indexOf('_b') > -1)) {
    $this.find('i').removeClass(hoverClass).addClass(iconClass)
  }
}

$(function () {
  var caseList = ''
  var caseStr = []
  var activeNavIndex = 0
  var index = 1
  var drop = 200
  serviceTopbar()
  getCustomerCases().then(function (result) {
    if (result.code === 0 || result.code === '0') {
      caseList = result.data
      getNavList(caseList)
      getCaseStr(activeNavIndex, caseList, caseStr)
      getCustomerCase(caseStr)
      $('.sidebar-content li').click(function () {
        iconHoverout($('.sidebar-content .active'))
        $('.sidebar-content').find('li.active').removeClass('active')
        $(this).addClass('active')
        iconHoverin($(this))
        $('.typical-customer-cases').empty()
        activeNavIndex = $(this).data('index')
        caseStr = []
        getCaseStr(activeNavIndex, caseList, caseStr)
        getCustomerCase(caseStr)
        index = 1
      })
      // 实现滚动条滚动到一定程度时显示后续的内容
      $(window).scroll(function () {
        if (($(document).scrollTop() + $(window).height() + drop) > $(document).height()) {
          index++
          caseStr = []
          var listlen = 0
          if (index * 10 < caseList[activeNavIndex].list.length) {
            listlen = index * 10
          } else {
            listlen = caseList[activeNavIndex].list.length
          }
          for (var i = (index - 1) * 10; i < listlen; i++) {
            caseStr.push(caseList[activeNavIndex].list[i])
          }
          getCustomerCase(caseStr)
        }
      })
      // 侧边栏hover时更换icon
      $('.sidebar-content li').hover(function () {
        if (!$(this).hasClass('active')) {
          iconHoverin($(this))
        }
      }, function () {
        if (!$(this).hasClass('active')) {
          iconHoverout($(this))
        }
      })
    } else {
      console.log(result.desc)
    }
  })
})



// WEBPACK FOOTER //
// ./src/js/entry/services/customer-case.js